import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { handleCategory } from '../../../../redux-store/action';
import { filterTagDiet, iconsTagDiet } from '../../../../global-functions/filterTagDiet';
import Images from "../../assets/images/images";
import { Skeleton } from '@material-ui/lab';
import {  Chip } from '@material-ui/core';
import { Link, useParams, useLocation } from "react-router-dom";

import AccessAlarmsIcon from "@mui/icons-material/AccessAlarms";
import { formatPreparingTime } from '../../../../utils';
import { get_lang } from '../../../../global-functions/apiGlobal';
import noImg from "../../assets/images/no-image.svg";
import { useTranslation, withTranslation } from 'react-i18next';
import "../Productv2/Productv2.scss"
const HomeProductCategory = ({ oldInvoice, branchIsLoading,  newStore,  setShowLandingPage }) => {
  const appDispatch = useDispatch();
  const appState = useSelector((state) => state);
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const isLoadingRef = useRef(false) // Prevent duplicate calls
  const loadedCategoriesRef = useRef('') // Track loaded categories
  const { t } = useTranslation();

  const handleGetProducts = async (cat_id, slug, parent_id = null) => {
    try{
      const trimmedCatId = cat_id ;
              const trimmedParentId = parent_id ? parent_id.trim() : null;
               let findCat = trimmedParentId == trimmedCatId ? appState.parentCategories.find((cat) =>   cat.id == trimmedParentId  )  : appState.categories.find((cat) =>   cat.id == trimmedCatId  );
            let findCategoryId = findCat?.id;
          
            if(findCat == undefined) {
             findCat = appState.categories.find((cat) =>   cat.slug == slug  )
             findCategoryId = findCat?.id
            }

      const res = await appDispatch(
        handleCategory(cat_id, appState, parent_id, slug, findCat, "homeProductCategory")
      );
      console.log(res,'products')
      let findCategory = res;
      let product = findCategory;
      let arr = [];
      const tagDietResponse = await iconsTagDiet( arr, product, Images, appDispatch );
      arr = tagDietResponse;
      if ( appState.productTags.length > 0 || appState.productDietaries.length > 0 && arr.length > 0 ) {
        const filterRes = await filterTagDiet( arr, appState );
        setProducts(prev => [...prev, ...filterRes]);
        return filterRes;
      }else{
        setProducts(prev => [...prev, ...arr]);
        return arr;
      }
    }
    catch(error){
      console.log(error)
    }
    }

  // Dispatch products to redux when they change
  useEffect(() => {
    if(products.length > 0 && !isLoading) {
    appDispatch({
      type: "setProducts",
      products: products,
    });
    }   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, isLoading])
  
  

  // Fetch products from all categories sequentially
  useEffect(() => {
    const fetchAllProducts = async () => {
    if(appState.categories.length > 0){
        // Create a unique key for current categories
        const categoriesKey = appState.categories.map(c => c.id).join(',')
        
        // Prevent duplicate calls if already loading or categories haven't changed
        if(isLoadingRef.current || loadedCategoriesRef.current === categoriesKey) {
          return
        }
        
        isLoadingRef.current = true
      setIsLoading(true)
        setProducts([]) // Reset products before fetching
        
        try {
          // Hit API one by one for each category
          for(let i = 0; i < appState.categories.length; i++){
            const apiProducts = await handleGetProducts(appState.categories[i].id, appState.categories[i].slug,  appState.categories[i].parent_id);
            console.log(apiProducts.length,'apiProducts', appState.categories[i].slug )
            if(apiProducts.length > 0){
              let data = {
                ...appState.categories[i],
                prodData: apiProducts
              }
              setProducts(prev => [...prev, data]);
            }
          }
          
          // Mark these categories as loaded
          loadedCategoriesRef.current = categoriesKey
        } catch (error) {
          console.error('Error fetching products:', error)
        } finally {
          setIsLoading(false)
          isLoadingRef.current = false
        }
      }
    }
    
    fetchAllProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appState.categories])
  



  const [cartBorderShow, setCartBorderShow] = useState(false)
  useEffect(() => {
    // if (slug == undefined) {
    //   slug = item.category.slug;
    // }
    let flag = true;
    if (appState?.cart?.length > 0) {
      // appState?.cart?.map((ele) => {
      //   if (ele?.productv2_id == item.id && flag) {
      //     setCartBorderShow(flag)
      //     flag = false
      //   }
      // })
    }
  }, []);
  const myRef = useRef(null);

  useEffect(() => {
    if (myRef.current?.id == appState.scrollKeyword - 1) {
      myRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
    // const swing = () => {
    //   if (myRef.current?.id == appState.scrollKeyword) {
    //     myRef.current.classList.add("swing");
    //     appDispatch({
    //       type: "setScrollKeyword",
    //       scrollKeyword: "",
    //     });
    //   }
    // };

    // setTimeout(swing, 500);
  }, [myRef]);

  const handleScroll = () => {
    appDispatch({
      type: "setScrollKeyword",
      scrollKeyword: 'null',
    });
  };
  
  return (
    <div className="home-product-category mx-2 mb-5">
      {(isLoading || branchIsLoading) ? (
        // Show skeletons while loading
    [0, 1, 2, 3, 4].map((a) => (
                      <div
                        key={a}
                        className={`row m-0 mb-4 mt-3 ${
                          appState.langValue == "ar" ? "" : ""
                        }`}
                      >
                        <div className="col-12  px-2">
                          <Skeleton
                            height={30}
                            width={180}
                            style={{
                              transform: "translate(2px, 0)",
                              marginBottom: "10px",
                            }}
                          />
                        </div>
                        <div className="col-5 col-md-4 px-2">
                          <Skeleton
                            variant="rect"
                            height={120}
                            style={{ borderRadius: "5px" }}
                          />
                        </div>
                        <div className="col-7 col-md-8 px-2">
                          <Skeleton
                            height={50}
                            style={{
                              transform: "translate(2px, 0)",
                              marginBottom: "10px",
                            }}
                          />
                          <Skeleton height={30} />
                          <Skeleton height={30} />
                        </div>
                      </div>
    ))
      ) : (
        // Show products when loaded
      
        <div className="products-container">

          {products.length > 0 ? (
            products.map((cat, ind) => (
               cat?.prodData?.length > 0 && (
                <div key={cat.id} style={{ 
                  marginBottom: '30px',
                  position: 'relative'
                } } className={`${appState.langValue == 'ar' ? "direction-rtl" : "direction-ltr"}`}>
                  {ind > 0 && (
                    <div style={{
                      height: '2px',
                      background: 'linear-gradient(90deg, transparent 0%, #e9ecef 20%, #dee2e6 50%, #e9ecef 80%, transparent 100%)',
                      margin: '0 0 20px 0',
                      borderRadius: '1px'
                    }}></div>
                  )}

              <div className={`category-header ${appState.langValue == 'ar' ? "direction-rtl" : "direction-ltr"}`} style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                padding: '12px 16px',
                margin: '20px 0 15px 0',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}>
                <h4 className={`text-capitalize mb-0 w-100 ${appState.langValue == 'ar' ? "mr-auto" : "ml-auto"}`} style={{
                  fontSize: '20px', 
                  fontWeight: '700', 
                  color: '#2c3e50',
                  letterSpacing: '0.5px',
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                  textAlign: appState.langValue == 'ar' ? 'right' : 'left'
                }}>
                  {get_lang(cat.name, appState.langValue)}
                </h4>
                <div style={{
                  fontSize: '12px',
                  color: '#6c757d',
                  marginTop: '4px',
                  fontWeight: '500',
                  textAlign: appState.langValue == 'ar' ? 'right' : 'left'
                }}>
                  {cat?.prodData?.length} {cat?.prodData?.length === 1 ? t("item") : t("items")}
                </div>
              </div>

              {cat?.prodData?.length > 0 && (
                cat?.prodData?.map((item, ind) => (
                  <div
                  className="prodContainer ani-boxes w-100 px-2"
                  key={ind}
                >
                  {ind === 0 ? "" : <hr />}
                  <div
          onClick={handleScroll}
          ref={myRef}
          // id={ind}
          className="col-12 p-1 px-1 direction-rtl inner_prod_v2 prod_main_div_v2"
          >
                  <div key={item.id || ind} className="product-item">
                    {/* Add your product component here */}
                    <Link
              // to={`${
              //   appState.storeInfo.progressive
              //     ? `/${item.category.slug}/${item.slug}?parent=${parent_id}&prodid=${item.id}&catid=${cat_id}`
              //     : `/${item.categorySlug}/${item.slug}?parent=${parent_id}&prodid=${item.id}&catid=${cat_id}`}`}
              to={ item.productUrl}
                       className={`prod_link ${item.quantity <= 0 && item.quantity != null? 'pointer-events-none' :'' }`}
              >
                <div className={`row prod_content_row ${appState.langValue == 'ar' ? "" : "justify-content-between"}  m-0 ${cartBorderShow ? appState.langValue == 'ar' ? "addToCartBorderAr pr-2" : "addToCartBorderEn " : ''}`}>
                  <div
    
                    className={` prod_categ_img px-0 ${false === "search"
                      ? "col-3 col-md-2 prod_categ_img_search_inhance"
                      : ""
                      } ${!appState.storeInfo?.categoryProductImage ? "hideProductImage" : ""}`}
                    style={{
                      background: `url(${item.image ? `${item.image}` : `${noImg}`})no-repeat center center / cover`,
                      width: "",
                      // center top/100% 100% no-repeat
                    }}
                  >
                    {/* <img
                        src={item.image ? `${item.image}` : `${noImg}`}
                        alt=""
                        className="img-fluid "
                      /> */}
                  </div>
                  <div className={` d-flex flex-column justify-content-between ${!appState.storeInfo?.categoryProductImage ? "col-12" : 
                  "col-6 col-md-6"} ${appState.langValue == 'ar' ? "pl-0 pr-3" : "pr-0 pl-2"}   prod_content ${false === "search"
                    ? "col-9 col-md-10"
                    : ""
                    }`} >
                    <div>
                      <h4 className={` ${appState.langValue === "ar"
                        ? "text-right"
                        : "text-left"}`}>
                        <strong className="  text-capitalize">
                          {`${item.name != null
                            ? get_lang(item.name, appState.langValue)
                            : "Not Available"
                            }`}
                          {/* {get_lang(item.name, appState.langValue).length} */}
                        </strong>
                      </h4>
                         <p className={`m-0 px-0  mb-1 d-flex align-items-center timer-content ${appState.langValue == 'ar' ? "direction-rtl" : "direction-ltr"} ${appState.langValue === "ar"
                              ? "text-left"
                              : "text-left"}`}>
    
                                {item?.preparing_time != null && (
                                  <>
                                  {/* <AccessAlarmsIcon className={`${appState.langValue == 'ar' ? "ml-1" : "mr-1"}`} /> {formatPreparingTime((Number(item?.preparing_time)), false)} */}
                                  </>
                                )}
                            </p>
                      {(item.description != null) && (get_lang(item.description, appState.langValue) != null)
                        ? get_lang(item.description, appState.langValue) != "N/A"
                          ? get_lang(item.description, appState.langValue)
                            .split("<br>")
                            .map(
                              (item, i) =>
                                i == 0 && (
                                  <p
                                    style={{ overflow: "hidden" }}
                                    key={i}
                                    className={`m-0 d-flex ${appState.langValue === "ar"
                                      ? "text-right direction-rtl "
                                      : "text-left direction-ltr"
                                      }`}
                                  >
                                    {item != "" && `${item}`}
                                  </p>
                                )
                            )
                          : ""
                        : ""}
                    </div>
                    {item.quantity <= 0 && item.quantity != null  ?  <h6 className={`d-flex ${appState.langValue == 'ar' ? "direction-rtl" : "direction-ltr"}`} style={{ color: "red" }}>
                    {t("single-product.Out-of-stock")}
                  </h6>   :  <div className={`d-flex flex-wrap ${appState.langValue == 'ar' ? "direction-rtl" : "direction-ltr"}   ${(appState?.storeInfo?.showCalorie && item?.calories != null) ? "hascalorie" : ""}`}>
                      {item.type == "Variable" ? (
                        <h6 className={` ${appState.langValue === "ar"
                          ? "text-right direction-rtl pl-2"
                          : "text-left direction-ltr pr-2"}`} >
                          <strong className="d-flex">
                            {parseFloat(item.min).toFixed(3)} &nbsp;
                            {get_lang(appState.storeInfo.storeCurrency, appState.langValue)} -{" "}
                            {parseFloat(item.max).toFixed(3)} &nbsp;
                            {get_lang(appState.storeInfo.storeCurrency, appState.langValue)}
                          </strong>
                        </h6>
                      ) : (
                       appState.productPriceShow && <h6 className={` ${appState.langValue === "ar"
                        ? "text-right pl-2"
                        : "text-left pr-2"}`}>
                        {item.price - item.discount == 0 ? (
                          <strong className="d-flex">
                            {t("product.Price-on-Selection")}
                          </strong>
                        ) : (
                          <strong className="d-flex">
                            {parseFloat(item.price - item.discount).toFixed(3)}{" "}
                            &nbsp;
  
                            {get_lang(appState.storeInfo.storeCurrency, appState.langValue)}                      
                            </strong>
                        )}
                      </h6>
                      )}
                      {(appState?.storeInfo?.showCalorie && item?.calories != null) && <span className=" d-flex">
                        <h6 className={` ${appState.langValue === "ar"
                          ? "text-right"
                          : "text-left"}`}> <strong className="d-flex">
    
                            { appState.productPriceShow && <span>|</span>}
    
                            <span className="px-2 calorieColor">
                              {parseFloat(item?.calories).toFixed(3)}{" "}
                              &nbsp;
                              Cal.
                            </span>
    
                          </strong>
    
                        </h6>
                      </span>
                      }
    
    
                    </div>}
    
    
                    {item.tags.length > 0 && <span className={`d-flex flex-wrap ${ind} ${appState.langValue == 'ar' ? "direction-rtl" : "direction-ltr"}`}>
                      {item.tags != [] &&
                        item.tags != undefined &&
                        item.tags.map((tag, index) => {
                          return (
                            <div
                              key={index}
                              className={` familyPoppins my-1  ${index >= 1 ? "" : ""
                                } ${appState.langValue === "ar"
                                  ? "d-flex justify-content-end  direction-ltr pl-1 "
                                  : "pr-1"
                                }`}
                            >
                              <Chip
                                style={{ color: tag.color ? tag.color : "#0000" }}
                                icon={
                                  tag.iconPath != null ? (
                                    <img src={tag.iconPath}  style={{ width: "16px" }}/>
                                  ) : (
                                    ""
                                  )
                                }
                                className="ChipClass"
                                label={`${get_lang(
                                  tag.name,
                                  appState.langValue
                                )}`}
                                variant="outlined"
                              />
                            </div>
                          );
                        })}
                      {item.food_preferences != [] &&
                        item.food_preferences != undefined &&
                        item.food_preferences.map((food_preference, index) => {
                          return (
                            <div
                              key={index}
                              className={` familyPoppins my-1  ${index >= 1 ? "" : ""
                                } ${appState.langValue === "ar"
                                  ? "d-flex justify-content-end  direction-ltr pl-1 "
                                  : "pr-1"
                                }`}
                            >
                              <Chip
                                style={{
                                  color: food_preference.color
                                    ? food_preference.color
                                    : "#0000",
                                }}
                                icon={
                                  food_preference.iconPath != null ? (
                                    <img src={food_preference.iconPath} />
                                  ) : (
                                    ""
                                  )
                                }
                                className="ChipClass"
                                label={`${get_lang(
                                  food_preference.name,
                                  appState.langValue
                                )}`}
                                variant="outlined"
                              />
                            </div>
                          );
                        })}
                    </span>}
    
    
    
    
                  </div>
    
    
                </div>
              </Link>
                  </div>
            </div>
    </div>
                ))
              ) }
              </div>
      )
            ))
          ) : (
            <div className="no-products">No products found</div>
          )}
        </div>
      )}
    </div>
  )
}

export default withTranslation  ()(HomeProductCategory)